export default __webpack_public_path__ + "static/media/logo_icon.48a39e79.svg";